import React from "react";
import { Badge } from "react-bootstrap";
import { getInitials } from "services/UtilityService";

function PersonBadge({variant,name}){
    return (
        <Badge pill bg={variant} style={{fontSize:'100%',  margin:'0 0.3em'}}>{getInitials(name)}</Badge>
    )
}
export default PersonBadge;